import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { changeSimulationStatus } from '../../../actions/Simulation/DataAction';
import { StateType } from '../../../reducers';
import { ActiveTabStatusSelection, activeTabStatusSelector } from '../../../reducers/GenericSelectors';
import { UNREAD_STATUS } from '../../../shared/constants';

import { SimulationVisualization } from '../../SimulationVisualization';
import EditorBottomBarRight from '../EditorBottomBar/EditorBottomBarRight';

import './Simulation.scss';
import './SimulationMain.scss';

interface SimulationMainProps {
  fullWidth: boolean;
  simulatePercentage: number;
  fetchingPercentage: boolean;
  fetchingPost: boolean;
  handlerCancelSimulation: () => void;
  data: any;
  isFetching: boolean;
  path: string[];
  showCode: boolean;
  showLearn: boolean;
  shouldResize: number;
  currentChildActiveTab: number | null;
  currentActiveTab: number;
  isMultiTab: boolean;
  size: number;
  handleCheckSubmission: () => void;
  handleSubmitAlpha: () => void;
  hasErrors: boolean;
  enabledIntro: boolean;
}

export const SimulationMain = ({
  fullWidth,
  fetchingPost,
  simulatePercentage,
  fetchingPercentage,
  data,
  isFetching,
  handlerCancelSimulation,
  path,
  showCode,
  showLearn,
  shouldResize,
  currentChildActiveTab,
  currentActiveTab,
  isMultiTab,
  size,
  handleCheckSubmission,
  handleSubmitAlpha,
  hasErrors,
  enabledIntro,
}: SimulationMainProps) => {
  const dispatch = useDispatch();
  const { tabIndex, childTabIndex, tabStatus } = useSelector<StateType, ActiveTabStatusSelection>(activeTabStatusSelector);

  if (tabStatus === UNREAD_STATUS) {
    dispatch(changeSimulationStatus(tabIndex, tabStatus, childTabIndex));
  }

  return (
    <div className={`editor-simulation ${fullWidth ? 'editor-simulation--full-width' : ''}`}>
      <div className="editor-simulation__bay">
        <SimulationVisualization
          fetchingPost={fetchingPost}
          simulatePercentage={simulatePercentage}
          fetchingPercentage={fetchingPercentage}
          data={data}
          handlerCancelSimulation={handlerCancelSimulation}
          isFetching={isFetching}
          path={path}
          showCode={showCode}
          showLearn={showLearn}
          shouldResize={shouldResize}
          currentChildActiveTab={currentChildActiveTab}
          currentActiveTab={currentActiveTab}
          isMultiTab={isMultiTab}
          size={size}
        />
        <EditorBottomBarRight
          path={path}
          data={data}
          isMultiTab={isMultiTab}
          handleCheckSubmission={handleCheckSubmission}
          handleSubmitAlpha={handleSubmitAlpha}
          currentChildActiveTab={currentChildActiveTab}
          currentActiveTab={currentActiveTab}
          isFetchingCheck={isFetching}
          hasErrors={hasErrors}
          enabledIntro={enabledIntro}
        />
      </div>
    </div>
  );
};

export default SimulationMain;
